export enum PURCHASE_OPTIONS_IDS {
  PERPETUAL_ID = 1,
  LEASE_ID = 2,
  MEMBERSHIP_RENEW_ID = 3,
  LEASE_RENEW_ID = 4,
  UPGRADE_LEASE_ID = 5,
  UPGRADE_PERPETUAL_ID = 6,
  UPGRADE_LEASE_TO_PERPETUAL_ID = 7,
  UPGRADE_PERPETUAL_WITH_MEMBERSHIP_ID = 11,
  UPGRADE_LEASE_TO_PERPETUAL_WITH_MEMBERSHIP_ID = 12,
  DOWNGRADE_PERPETUAL_TO_LEASE_ID = 15,
  CLOUD_LICENSE_ID = 16,
  CLOUD_LICENSE_RENEW_ID = 17,
  CLOUD_LICENSE_UPGRADE_ID = 18,
}

export const PURCHASE_OPTIONS_UPGRADE_IDS = [
  PURCHASE_OPTIONS_IDS.UPGRADE_LEASE_ID,
  PURCHASE_OPTIONS_IDS.UPGRADE_PERPETUAL_ID,
  PURCHASE_OPTIONS_IDS.UPGRADE_LEASE_TO_PERPETUAL_ID,
  PURCHASE_OPTIONS_IDS.UPGRADE_PERPETUAL_WITH_MEMBERSHIP_ID,
  PURCHASE_OPTIONS_IDS.UPGRADE_LEASE_TO_PERPETUAL_WITH_MEMBERSHIP_ID,
  PURCHASE_OPTIONS_IDS.CLOUD_LICENSE_UPGRADE_ID,
];
